var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonfloat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 42.5H17.5V25H22.5V42.5ZM32.5 42.5H27.5V17.5H32.5V42.5ZM42.5 42.5H37.5V32.5H42.5V42.5ZM48.75 47.75H11.25V12.5H48.75V47.75ZM48.75 7.5H11.25C8.5 7.5 6.25 9.75 6.25 12.5V47.5C6.25 50.25 8.5 52.5 11.25 52.5H48.75C51.5 52.5 53.75 50.25 53.75 47.5V12.5C53.75 9.75 51.5 7.5 48.75 7.5Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonfloat);
export default __webpack_public_path__ + "static/media/buttonfloat.ede48d57a11ef0314efa030057058b69.svg";
export { ForwardRef as ReactComponent };